import { z } from 'zod'

/**
 * Which template an outbound email used. Mirrors `EmailKind` in the Prisma schema.
 */
export const EMAIL_KINDS = ['invitation', 'password_reset', 'magic_link', 'billing', 'other', 'integration'] as const

export const emailKindSchema = z.enum(EMAIL_KINDS)

export type EmailKind = z.infer<typeof emailKindSchema>
